export default {
  setPayoutRequestsListState(context, list) {
    context.list = list;
  },
  mutatePayoutRequestsListState(context, item) {
    context.list = [item, ...context.list];
  },
  setCreateLoadingState(context, loading) {
    context.createLoading = loading;
  }
};
